var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择职务属性"},on:{"change":_vm.onSelectJobChanged},model:{value:(_vm.selectJob),callback:function ($$v) {_vm.selectJob=$$v},expression:"selectJob"}},_vm._l((_vm.jobs),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.label,"value":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }